import './App.css';
import React, { useState, useEffect } from 'react';

import Home from './Pages/Home';
import Eleanor from './Pages/Eleanor';
import Mikey from './Pages/Mikey';
import StoryGenerator from './Pages/StoryGenerator';

import { apiCall } from './api';

import { Routes, Route } from 'react-router-dom';





function App() {

  const [currentPage, setCurrentPage] = useState('Home');

  const [authenticated, setAuthenticated] = useState(false);

  const checkAuth = async () => {
    const pin = localStorage.getItem('mikeyandeleanor_auth_pin');
    if (pin) {
      setAuthenticated(true);
    }
    else {
      const entered_pin = prompt('Enter the pin please!');

      const [success, resp] = await apiCall({
                  method: 'post',
                  url: '/mikeyandeleanor/auth/check_pin/',
                  data: {
                      entered_pin: entered_pin
                  }
              });

      if (resp.success) {
        setAuthenticated(true);
        localStorage.setItem('mikeyandeleanor_auth_pin', entered_pin);
      }
      else {
        alert('Invalid pin! Please try again.');
        checkAuth();
      }
    }
  };

  useEffect(() => {
    checkAuth();
  }
  , []);




  return (
      <div className="App"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}>

        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/story' element={<StoryGenerator />} />
          <Route path='/ella-bella' element={<Eleanor />} />
          <Route path='/mikey-moo' element={<Mikey />} />

        </Routes>
      
        
      </div>
  );
}

export default App;
